import Vue from 'vue'
import Vuex from 'vuex'
import { IUserState } from '@/store/modules/user'
import { IAppState } from '@/store/modules/app'
import { IPartnersGridState } from '@/features/partners/store/partners-grid'
import { IContractsGridState } from '@/store/modules/contracts-grid'
import { ICampuriPersonalizateGridState } from '@/features/campuri-personalizate/store/campuri-personalizate-grid'
import { ILicitatieAchizitieGridState } from '@/features/licitatie-achizitie/store/licitatie-achizitie-grid'
import { IOfertaLicitatieAchizitieGridState } from
  '@/features/oferta-licitatie-achizitie/store/oferta-licitatie-achizitie-grid'
import { IMappingAdRolesGridState } from '@/features/mapping-ad-roles/store/mapping-ad-roles-grid'
import { IUsersGridState } from '@/features/users/store/users-grid'
import { INotificationSubscriptionGridState } from '@/features/notification-subscription/store/notification-subscription-grid'

Vue.use(Vuex)

export interface IRootState {
  app: IAppState
  user: IUserState
  partnersGrid: IPartnersGridState
  contractsGrid: IContractsGridState
  campuriPersonalizateGrid: ICampuriPersonalizateGridState
  licitatieAchizitieGrid: ILicitatieAchizitieGridState
  ofertaLicitatieAchizitieGrid: IOfertaLicitatieAchizitieGridState
  mappingAdRolesGrid: IMappingAdRolesGridState
  usersGrid: IUsersGridState
  notificationSubscriptionGrid: INotificationSubscriptionGridState
}

// Declare empty store first, dynamically register all modules later.
export default new Vuex.Store<IRootState>({})
